export default "{\n    \"searchPlaceholder\": \"Search\"\n}\n"